module.exports = __webpack_public_path__ + "static/media/271.8cecd82f.wav";